import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import SettlementTimeRecordEditForm from "./SettlementTimeRecordEditForm";
import {
  pageSettlementTimeRecordDto,
  searchSettlementTimeRecordDto,
} from "../../service/SettlementTimeRecordRequest";

import {
  CircularProgress,
  Typography,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Paper,
  Box,
} from "@material-ui/core";

import { SettlementTimeRecordAddButtonControl } from "./style/SettlementTimeRecordStyle";

export default function SettlementTimeRecordTable() {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([["Loading Data..."]]);
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortOrder, setSortOrder] = useState(0);
  const [open, setOpen] = useState(false);

  const [addOpen, setAddOpen] = useState(false);
  const [
    editSettlementTimeRecordDto,
    setEditSettlementTimeRecordDto,
  ] = useState({});

  const [refreshFlag, setRefreshFlag] = useState(false);

  const [searchName, setSearchName] = useState("");

  const [searchRefreshFlag, setSearchRefreshFlag] = useState(false);

  const searchSettlementTimeRecord = () => {
    console.log("======searchSettlementTimeRecord", searchName);
    setSearchRefreshFlag(true);
  };

  const addSettlementTimeRecord = () => {
    console.log("======handle add addSettlementTimeRecord");
    setAddOpen(!addOpen);
  };

  const handleClose = () => {
    console.log("======handle close");
    setOpen(!open);
  };

  const handleEditSubmit = () => {
    console.log("======handle edit submit");
    setOpen(!open);

    setTimeout(() => {
      setRefreshFlag(true);
    }, 1000);
  };

  const changePage = (page, sortOrder) => {
    setIsLoading(true);
    console.log("===page", page);
    page = page + 1;
    initData(page, 10);
  };

  const editSettlementTimeRecordData = (tableMeta) => {
    const row = tableMeta.rowIndex;
    console.log("row", row);
    setOpen(!open);
    const editSettlementTimeRecordDto = data[row];
    setEditSettlementTimeRecordDto(editSettlementTimeRecordDto);
  };
  console.log("count===", count);
  const options = {
    filterType: "dropdown",
    responsive: "vertical",
    serverSide: true,
    count: count,
    rowsPerPage: 10,
    rowsPerPageOptions: [],
    sortOrder: { sortOrder },
    print: false,
    download: false,
    filter: false,
    viewColumns: false,
    onTableChange: (action, tableState) => {
      console.log(action, tableState);

      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want

      switch (action) {
        case "changePage":
          changePage(tableState.page, tableState.sortOrder);
          break;
        case "sort":
          this.sort(tableState.page, tableState.sortOrder);
          break;
        default:
          console.log("action not handled.");
      }
    },
  };

  const initData = (index, pageSize) => {
    setIsLoading(true);
    pageSettlementTimeRecordDto(index, pageSize).then((res) => {
      // const albums = res.albums;
      console.log("====data", res.data);
      if (res && res.data) {
        setData(res.data.records);
        setCount(res.data.total);
      }

      setIsLoading(false);

      setPage(index);
    });
  };

  const searchSettlementTimeRecordData = (index, pageSize, searchName) => {
    setIsLoading(true);
    searchSettlementTimeRecordDto(index, pageSize, searchName).then((res) => {
      // const albums = res.albums;
      console.log("====data", res.data);
      if (res && res.data) {
        setData(res.data.records);
        setCount(res.data.total);
      }

      setIsLoading(false);

      setPage(index);
    });
  };
  // Similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    // Update the document title using the browser API

    initData(page, 10);
  }, [refreshFlag]);

  useEffect(() => {
    console.log("===searchSettlementTimeRecordData=");
    if (searchRefreshFlag) {
      console.log("searchName===", searchName);
    }

    if (!searchName) return;
    searchSettlementTimeRecordData(page, 10, searchName);

    setSearchRefreshFlag(false);
  }, [searchRefreshFlag]);

  const configurationData = {
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    data: [["Loading Data..."]],
    columns: [
      {
        name: "id",
        label: "id",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            // Here you can render a more complex display.
            // You're given access to tableMeta, which has
            // the rowData (as well as the original object data).
            return value.toString();
          },
        },
      },

      {
        name: "status",
        label: "Status",
        options: {},
      },
      {
        name: "settlementStartTime",
        label: "Settlement Start Time",
        options: {},
      },
      {
        name: "settlementEndTime",
        label: "Settlement End Time",
        options: {},
      },
      {
        name: "settlementRecordId",
        label: "Settlement Record Id",
        options: {},
      },
      {
        name: "storeId",
        label: "Store Id",
        options: {},
      },
      {
        name: "acquirerId",
        label: "Acquirer Id",
        options: {},
      },
      {
        name: "creationTime",
        label: "Create Time",
        options: {},
      },
      {
        name: "Action",
        options: {
          filter: true,
          sort: false,
          empty: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <Box>
                <Button
                  variant="outlined"
                  size="small"
                  color="primary"
                  onClick={(e) => editSettlementTimeRecordData(tableMeta)}
                >
                  Edit
                </Button>
              </Box>
            );
          },
        },
      },
    ],
  };

  return (
    <div>
      <div>
        <TextField
          id="id"
          label="Id"
          value={searchName}
          variant="standard"
          onChange={(e) => setSearchName(e.target.value)}
        />
      </div>

      <SettlementTimeRecordAddButtonControl>
        <Button
          className="btn right"
          variant="outlined"
          onClick={searchSettlementTimeRecord}
          color="primary"
        >
          Search
        </Button>
      </SettlementTimeRecordAddButtonControl>

      <MUIDataTable
        title={
          <Typography variant="h6">
            Settlement Time Record list
            {isLoading && (
              <CircularProgress
                size={24}
                style={{ marginLeft: 15, position: "relative", top: 4 }}
              />
            )}
          </Typography>
        }
        data={data}
        columns={configurationData.columns}
        options={options}
      />

      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            width: "100%",
            height: "50%",
          },
        }}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>Edit Settlement Time Record</DialogTitle>
        <DialogContent>
          <SettlementTimeRecordEditForm
            handleEditClose={handleClose}
            handleEditSubmit={handleEditSubmit}
            editSettlementTimeRecordDto={editSettlementTimeRecordDto}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
